
import { ErrorBoundary } from "react-error-boundary";
import PropTypes from 'prop-types';
export default function GlobalErrorBoundary({
  children,
  FallbackComponent,
  onReset,
}) {
    
  const DefaultFallback = ({ resetErrorBoundary }) => (
    <div style={{ padding: 16 }}>
      <h2>Something went wrong</h2>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
  
DefaultFallback.propTypes = {
  resetErrorBoundary: PropTypes.func.isRequired,
};

return (
    <ErrorBoundary
      FallbackComponent={FallbackComponent || DefaultFallback}
      onError={(error, info) => {
        console.error("Global Error Caught:", error, info);
      }}
      onReset={() => {
        if (typeof onReset === "function") {
          window.location.reload();
        } else {
          console.log("Error boundary reset");
        }
      }}
      resetKeys={[window.location.pathname]} 
    >
      {children}
    </ErrorBoundary>
  );
}


GlobalErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  FallbackComponent: PropTypes.elementType,
  onReset: PropTypes.func,
  onError: PropTypes.func,
};


